import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { AiOutlineControl } from "react-icons/ai";
import { IoCheckmarkCircle } from "react-icons/io5";
import { LuArrowRight } from "react-icons/lu";
import UnitsIcons from "./UnitsIcons";
import { setSidebarCollapsed } from "../store/actions/authActions";
import { CiCircleAlert } from "react-icons/ci";
import { LuPanelLeft } from "react-icons/lu";


const ComplianceTopBar = (props) => {
    const {
        menuitem,
        setMenuItem,
        activeComplianceId,
        complianceStandards,
        setSidebarCollapsedFN,
        sidebar_collapsed,
        openReport,
    } = props;

    ////console.log("active comlpiance id: ", activeComplianceId);
    const getSvgProps = (path) => {
        return menuitem === path
            ? { fill: "#3b3b3b", what: path }
            : { fill: "#c3cfd1", what: path };
    };

    ////console.log(complianceStandards);
    const activeCompliance =
        complianceStandards?.find((standard) => standard.compliance_id === activeComplianceId) || {};
    const activeComplianceName = activeCompliance?.name || "N/A";
    const activeComplianceColor = activeCompliance?.color || "";

    return (
        <div
            className={`flex w-full h-16 bg-[#F0F0F2] transition-width duration-300 border-b border-gray-300 shadow`}
        >
            {sidebar_collapsed && (
                <div>
                    <button
                        className="p-5 pl-0 ml-5"
                        onClick={() => setSidebarCollapsedFN(!sidebar_collapsed)}
                        title="Toggle sidebar"
                    >
                        <div className="relative flex items-center justify-center w-8 h-8 hover:bg-white hover:rounded-full mt-[-2px] transition">
                            <LuPanelLeft className="w-5 h-5 text-[#3b3b3b] hover:text-black" />
                        </div>
                    </button>
                </div>
            )}
            
            <nav className="flex flex-row justify-center w-full">
                <div className={`flex items-center p-2 mx-8 text[#464646] text-mm`}>
                    <div
                        title={activeComplianceName}
                        className={`flex items-center justify-center w-8 h-8 m-2 rounded-xl hover:bg-[#3b3b3b] hover:bg-opacity-20 ml-0`}
                        style={{ backgroundColor: activeComplianceColor }}
                    >
                        <span className="text-white font-bold text-[12px]">
                            {activeComplianceName !== "N/A"
                                ? activeComplianceName
                                      .split(" ")
                                      .map((word) => word.charAt(0).toUpperCase())
                                      .slice(0, 2)
                                      .join("")
                                : "NA"}
                        </span>
                    </div>
                    <span className={`ml-2 text-black`}>{activeComplianceName}</span>
                </div>

                {[
                    { id: "dashboards", label: "Dashboard" },
                    { id: "risk", label: "Risk" },
                    { id: "controls", label: "Controls", icon: IoCheckmarkCircle },
                    { id: "actions", label: "Actions" },
                    { id: "incidents", label: "Incidents", icon: CiCircleAlert },
                    { id: "files", label: "Files" },
                    // {
                    //     id: "create_report",
                    //     label: "Create Report",
                    //     action: openReport, // Call the `openReport` function for report generation
                    // },
                ].map(({ id, label, icon: Icon, action }) => (
                    <button
                        key={id}
                        onClick={() => {
                            if (action) {
                                action(); // Execute the `openReport` function
                            } else {
                                setMenuItem(id);
                            }
                        }}
                        className={`flex items-center p-2 mx-8 text[#464646] hover:bg-white text-mm ${
                            menuitem === id
                                ? "border-b-2 border-[#3b3b3b] text-[#3b3b3b]"
                                : "text-gray-500"
                        }`}
                    >
                        {Icon ? (
                            <Icon
                                className={`w-6 h-6`}
                                style={{ color: menuitem === id ? "#3b3b3b" : "#c3cfd1" }}
                            />
                        ) : (
                            <UnitsIcons {...getSvgProps(id)} className={`w-6 h-6`} />
                        )}
                        <span className={`ml-2`}>{label}</span>
                    </button>
                ))}
            </nav>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        sidebar_collapsed: state.auth.sidebar_collapsed,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSidebarCollapsedFN: (collapsed) => dispatch(setSidebarCollapsed(collapsed)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceTopBar);